import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import Point from "slotworks/utils/geom/point";

export default class ICSpinRecord extends SpinRecord {
    public addedCoins: number[] = [0, 0, 0, 0, 0];
    public potsValues: number[] = [0, 0, 0, 0, 0];
    public persistedPotsValues: Map<number, number[]> = new Map();

    public potTriggeredFeatures: string[];
    public instantWin: number;
    public isJackpotWon: boolean = false;
    public underCoinSymbols: Map<Point, string> = new Map();
    public bonusTriggered: boolean;
}
